export type ThemeMode = 'default' | 'dark' | 'light';

export function normalizeTheme(value: unknown): ThemeMode {
  const theme = String(value ?? '').toLowerCase();
  if (theme === 'dark' || theme === 'light') return theme;
  return 'default';
}

export function readAppliedTheme(): ThemeMode {
  const root = document.documentElement;
  if (root.classList.contains('dark')) return 'dark';
  if (root.classList.contains('theme-light')) return 'light';
  return 'default';
}

export function applyTheme(theme: ThemeMode) {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.classList.toggle('theme-light', theme === 'light');
  root.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
}

const THEME_STORAGE_KEY = 'accounting-theme';

export function rememberTheme(theme: ThemeMode) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Private mode can block storage. The choice still applies for this visit.
  }
}

export function rememberedTheme(): ThemeMode | null {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (!saved) return null;
    return normalizeTheme(saved);
  } catch {
    return null;
  }
}
